import { render, staticRenderFns } from "./LogsticsIndex.vue?vue&type=template&id=3042df27&scoped=true&"
import script from "./LogsticsIndex.vue?vue&type=script&lang=js&"
export * from "./LogsticsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3042df27",
  null
  
)

export default component.exports